import type { I18nScope } from 'vue-i18n';
import type enUS from '../../locales/en-US';

export type MessageSchema = typeof enUS;

export enum Locales {
    enUS = 'en-US',
    zhCN = 'zh-CN',
    deDE = 'de-DE',
    frFR = 'fr-FR',
    nlNL = 'nl-NL',
    itIT = 'it-IT',
    viVN = 'vi-VN',
    esES = 'es-ES',
    plPL = 'pl-PL',
    ptPT = 'pt-PT',
    trTR = 'tr-TR',
    csCZ = 'cs-CZ',
    huHU = 'hu-HU',
    ruRU = 'ru-RU',
    arSA = 'ar-SA', //
    bgBG = 'bg-BG', //
    daDK = 'da-DK', //
    fiFI = 'fi-FI', //
    zhTW = 'zh-TW',
    hrHR = 'hr-HR', //
    lvLV = 'lv-LV', //
    ltLT = 'lt-LT', //
    roRO = 'ro-RO', //
    nbNO = 'nb-NO', //
    ptBR = 'pt-BX', //
    svSE = 'sv-SE',
    skSK = 'sk-SK',
    slSI = 'sl-SI', //
    thTH = 'th-TH',
    ukUA = 'uk-UA',
    elGR = 'el-GR', //
    etEE = 'et-EE',
    kkKZ = 'kk-KZ', //
    heIL = 'he-IL',
}

export const useTypedI18n = (local?: boolean) => {
    const params = local
        ? {
            useScope: 'local' as I18nScope,
        }
        : undefined;
    return useI18n<[MessageSchema], Locales>(params);
};

export const useLocalI18n = () => {
    const i18n = useI18n({
        useScope: 'local',
    });

    return {
        i18n,
        mergeMessages: (locales: Parameters<typeof i18n.mergeLocaleMessage>[]) => {
            locales.forEach((locale) => {
                i18n.mergeLocaleMessage(...locale);
            });
        },
    };
};
